(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.mashInitialized === 'true') return;
    root.dataset.mashInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mash-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mash-dot]'));
    var previous = root.querySelector('[data-mash-prev]');
    var next = root.querySelector('[data-mash-next]');
    var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var autoplay = root.dataset.autoplay === 'true';
    var delay = Math.max(2500, parseInt(root.dataset.autoplayDelay || '6000', 10));
    var timer = null;

    if (slides.length < 2) return;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { show(current + 1); }, delay);
    }

    if (previous) previous.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { show(index); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    show(current);
    start();
  }

  function initCarousel(root) {
    if (!root || root.dataset.mashInitialized === 'true') return;
    root.dataset.mashInitialized = 'true';

    var scroller = root.querySelector('[data-mash-scroller]');
    var previous = root.querySelector('[data-mash-carousel-prev]');
    var next = root.querySelector('[data-mash-carousel-next]');
    if (!scroller || !previous || !next) return;

    function step() {
      var firstCard = scroller.firstElementChild;
      if (!firstCard) return scroller.clientWidth * 0.85;
      var gap = parseFloat(window.getComputedStyle(scroller).columnGap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    }

    function update() {
      previous.disabled = scroller.scrollLeft <= 4;
      next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    }

    previous.addEventListener('click', function () {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCompare(root) {
    if (!root || root.dataset.mashInitialized === 'true') return;
    root.dataset.mashInitialized = 'true';
    var range = root.querySelector('[data-mash-compare-range]');
    if (!range) return;

    function update() {
      root.style.setProperty('--mash-compare-position', range.value + '%');
      range.setAttribute('aria-valuetext', range.value + '%');
    }

    range.addEventListener('input', update);
    update();
  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-mash-hero]').forEach(initHero);
    context.querySelectorAll('[data-mash-carousel]').forEach(initCarousel);
    context.querySelectorAll('[data-mash-compare]').forEach(initCompare);
  }

  if (!window.MashHome) {
    window.MashHome = { init: init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  } else {
    window.MashHome.init(document);
  }
})();
